import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@linaria/react';
const Bodytext = (props) => {
  const { html, theme } = props;

  return (
    <React.Fragment>
      <BodyTextStyled theme={theme} dangerouslySetInnerHTML={{ __html: html }} />
    </React.Fragment>
  );
};

Bodytext.propTypes = {
  html: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired,
};

export default Bodytext;

const BodyTextStyled = styled.div`
  animation-name: bodytextEntry;
  animation-duration: ${(props) => props.theme.time.duration.long};
  // disable text selection
  -webkit-user-select: none; /* Safari */
  -webkit-touch-callout: none;
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */

  @keyframes bodytextEntry {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  h2,
  h3 {
    margin: 1.5em 0 1em;
  }

  h2 {
    font-size: ${(props) => props.theme.font.size.l};
    line-height: ${(props) => props.theme.font.lineHeight.s};
  }

  h3 {
    font-size: ${(props) => props.theme.font.size.m};
    line-height: ${(props) => props.theme.font.lineHeight.m};
  }

  h4 {
    font-size: ${(props) => props.theme.font.size.sm};
    line-height: ${(props) => props.theme.font.lineHeight.s};
  }

  p {
    font-size: ${(props) => props.theme.font.size.sm};
    line-height: ${(props) => props.theme.font.lineHeight.xxxl};
    margin: 1.5em 0 1.5em;
  }

  ul {
    list-style: circle;
    margin: 0 0 1.5em;
    padding: 0 0 0 1.5em;
  }
  li {
    font-size: 1.1em;
    margin: 0.7em 1em;
    line-height: ${(props) => props.theme.font.lineHeight.xxl};
  }

  u {
    background-color: transparent;
    padding: 0px 0.1rem;
    box-shadow: var(--underline-color) 0px -0.7rem inset, transparent 0px -0.7rem inset;
    text-decoration: unset;
  }

  a {
    font-weight: ${(props) => props.theme.font.weight.bold};
    color: ${(props) => props.theme.color.brand.primary};
    text-decoration: underline;
  }

  p a,
  ul li a {
    text-decoration: none;
    box-shadow: inset 0 -4px 0 var(--underline-color-link);
  }

  p span.gatsby-resp-image-wrapper,
  figure span.gatsby-resp-image-wrapper {
    border-radius: ${(props) => props.theme.size.radius.default};
    overflow: hidden;
    border: 1px solid ${(props) => props.theme.line.color};
  }
  pre {
    padding: 1em;
    margin: 0.5em 0;
    overflow: auto;
    border-radius: 0.3em;
  }
  code {
    background: var(--backgroundCodeBlock);
    color: var(--textCodeBlock);
    font-family: Consolas, Monaco, Andale Mono, Ubuntu Mono, monospace;
    font-size: 1em;
    text-align: left;
    white-space: pre;
    word-spacing: normal;
    word-break: normal;
    word-wrap: normal;
    line-height: 1.5;
    tab-size: 4;
    hyphens: none;
    text-shadow: 0 1px rgb(0 0 0 / 30%);
    padding: 0.1em 0.3em 0.2em;
  }

  p strong {
    background-color: var(--underline-color);
    padding-right: 2px;
    box-shadow: var(--bg) 5px 0.8em 0px inset;
  }

  p strong code,
  p code {
    background: var(--backgroundCode);
    text-shadow: none;
    color: var(--textCode);
    padding: 0.1em 0.3em 0.2em;
    border-radius: 0.1em;
    font-size: 1em;
  }
  pre {
    margin: 0 auto;
    padding: 1em;
    border-left: 5px solid hsl(26, 83%, 50%);
    background: var(--codeMarkdownBg);
  }
  blockquote {
    margin: 0 auto;
    padding: 1em;
    border-left: 5px solid #999;
    background: var(--blockquoteBg);
  }
  blockquote:before {
    display: none;
  }
  pre:not(:first-of-type),
  blockquote:not(:first-of-type) {
    margin-top: 0.5em;
  }
  blockquote footer {
    margin-top: 0.5em;
    padding: 0;
    color: #777;
    font-size: 12pt;
    text-align: left;
    font-style: italic;
  }
  blockquote footer:before {
    content: '— ';
  }

  blockquote:nth-of-type(even) {
    text-align: right;
    border-left: none;
    border-right: 5px solid #999;
  }
  blockquote:nth-of-type(even) footer {
    text-align: right;
  }
  blockquote:nth-of-type(even) footer:before {
    content: '';
  }
  blockquote:nth-of-type(even) footer:after {
    content: ' —';
  }

  @element 'blockquote' and (min-width: 300px) {
    blockquote {
      padding: 1em 20% 1em 1em;
    }
    blockquote p {
      font-size: 14pt;
    }

    blockquote:nth-of-type(even) {
      padding: 1em 1em 1em 20%;
    }
  }

  blockquote p {
    margin: auto;
    color: var(--blockquoteText);
    font-size: 17pt;
    line-height: ${(props) => props.theme.font.lineHeight.xxl};
  }
  pre code.language-Markdown {
    margin: auto;
    color: var(--codeMarkdownText);
    font-size: 1em;
    line-height: ${(props) => props.theme.font.lineHeight.xxl};
    background: unset;
    text-shadow: unset;
    padding: unset;
    white-space: break-spaces;
  }

  table {
    border-radius: 5px;
    font-size: 12px;
    font-weight: normal;
    border: none;
    border-collapse: collapse;
    width: 100%;
    max-width: 100%;
    background-color: white;
  }

  table td {
    padding: 8px;
  }

  table th {
    padding: 8px;
  }

  table td {
    border-right: 1px solid #f8f8f8;
    font-size: 14px;
  }

  table thead th {
    color: #ffffff;
    background: #4fc3a1;
  }

  table thead th:nth-child(odd) {
    color: #ffffff;
    background: #324960;
  }

  table tr:nth-child(even) {
    background: #f8f8f8;
  }

  @media (max-width: 680px) {
    h2 {
      font-size: ${(props) => props.theme.font.size.m};
      line-height: ${(props) => props.theme.font.lineHeight.s};
    }

    h3 {
      font-size: ${(props) => props.theme.font.size.sm};
      line-height: ${(props) => props.theme.font.lineHeight.m};
    }

    h4 {
      font-size: ${(props) => props.theme.font.size.s};
      line-height: ${(props) => props.theme.font.lineHeight.s};
    }

    p {
      font-size: ${(props) => props.theme.font.size.xs};
      margin: 1.5em 0 1.5em;
    }

    li {
      font-size: 1.1em;
      margin: 0.7em 1em;
      line-height: ${(props) => props.theme.font.lineHeight.xxl};
    }

    blockquote p {
      font-size: ${(props) => props.theme.font.size.sm};
    }
  }
`;
